import style from '@/fsd/shared/ui/static/css/commonStyle.module.scss';
import cx from 'classnames';
import React from 'react';
import { TOUR_STEP_IDS } from '@fsd/entities/onboarding/model/consts/tourStepIds';

export const Table = (props) => {
  return (
    <div
      data-testid={props.dataTestid}
      className={cx(style.table, props.className, props.tableClassName)}
    >
      {props.children}
    </div>
  );
};

export default Table;
